import { Box } from '@mui/material'
import { SelectWithLabel } from 'Components/SelectWithLabel'
import { TextFieldWithLabel } from 'Components/TextField'
import { useAuth } from 'hooks/use-auth'
import { sendGet } from 'hooks/use-fetch'
import { useEffect, useState } from 'react'
import { type lookup, Role } from 'core/types'

export interface AccessRequestApprovalSearchCriteria {
  approvalStatus: string
  childName: string
  userName: string
  isdID: number | undefined
}

export function AccessRequestSearchOptions (props: { current: AccessRequestApprovalSearchCriteria, onChange: (newSearch: AccessRequestApprovalSearchCriteria) => void }): JSX.Element {
  const { user } = useAuth()
  const [isds, setIsds] = useState<lookup[]>([])

  const statusOptions: Array<{ id: string, name: string }> = [
    { id: 'P', name: 'Pending' },
    { id: 'Y', name: 'Approved' },
    { id: 'N', name: 'Denied' }
  ]

  useEffect(() => {
    const loadData = async (): Promise<void> => {
      const resp = await sendGet('/FacilityDetails/GetAllIsds', {})
      setIsds(resp.response)
    }

    if (user?.securityLevel === Role.MIECC_ADMIN) {
      void loadData()
    }
  }, [])

  const handleChange = (e: any): void => {
    props.onChange({ ...props.current, [e.target.name]: e.target.value })
  }

  return (<Box sx={{ boxSizing: 'border-box', alignItems: 'center', p: '4px 0px', gap: '10px', display: 'flex', flexDirection: 'row' }}>
    {user?.securityLevel === Role.MIECC_ADMIN && <SelectWithLabel
      name='isdID'
      label='ISD'
      width='300px'
      value={props.current.isdID}
      options={isds}
      onChange={handleChange}
      includeNoneOption={true}
    />
    }
    <TextFieldWithLabel
      label='Requested By'
      onChange={handleChange}
      name='userName'
      maxWidth='205px'
      value={props.current.userName}
      data-testid="name-search"
    />
    <TextFieldWithLabel
      label='Child Name'
      onChange={handleChange}
      name='childName'
      maxWidth='205px'
      value={props.current.childName}
      data-testid="name-search"
    />
    <SelectWithLabel
      name='approvalStatus'
      label='Status'
      width='125px'
      value={props.current.approvalStatus}
      options={statusOptions}
      onChange={handleChange}
    />
  </Box>
  )
}
